<template>

  <el-row>
    <el-col align="left">
      <edit-pane ref="sra" prefix="Payment: ":title="form.summary"
      :editable="disabled"
      :adding="true"
      :is-edit="false"
      @cancel="onCancel" @add="onAdd" />


      <el-form  :model="form" inline label-position="left">
        <date-input v-if="form.started || !disabled" v-model="form.started" label="Started" :disabled="disabled" />
        <date-input v-if="form.expiry || !disabled" v-model="form.expiry" label="Expiry" :disabled="disabled" />
        <currency-input v-if="form.amount || !disabled"  label="Amount" v-model="form.amount" :disabled="disabled" />

        <el-form-item v-if="showTax() && this.taxes" :label="taxLabel">
          <b>{{this.formatNumber(this.taxes, 2)}}</b>
        </el-form-item>

        <el-form-item v-if="showTax() && this.totals" label="Total">
          <b>{{this.formatNumber(this.totals, 2)}}</b>
        </el-form-item>
      </el-form>

    </el-col>
  </el-row>

</template>


<script>

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

export default {

  mixins: [DateMixins, NumberMixins, PostMixins],

  props: {

    renewals: {
      type: Array,
      required: true
    },

    siteId: {
      type: Number,
      required: true
    }

  },



  methods: {

    resetData () {
      this.form = {}
    },

    success (data) {
//      console.log('revenue resp', data)
      this.renewals.push(data)
      this.$emit('update', this.renewals)
      this.resetData()
    },

    onCancel () {
      this.resetData()
      this.disabled = true
    },

    onAdd () {
      this.disabled = false
    },

    onSave () {
      if (!this.form.site_id && this.localSiteId) {
        this.form.site_id = this.localSiteId
      }

      this.form.started = this.formatDateSql(this.form.started)
      this.form.expiry = this.formatDateSql(this.form.expiry)

      this.saveForm(this, '/revenue', (this.adding ? null : this.form.id), this.form,  'Revenue Schedule', this.success)
      this.disabled = true
      //      this.resetData()

    },

    onClose () {
      this.resetData()
      this.disabled = true
    }

  },



  computed: {

    taxes () {
      this.form.tax = this.taxDue(this.form.amount)
      return this.form.tax
    },

    totals () {
      this.form.total = this.totalDue(this.form.amount, this.form.tax)
      return this.form.total
    }

  },

  data () {
    return {
      disabled: false,
      taxLabel: settings.taxLabel,
      form: this.getMeta('revenue').struct
    }
  },

  mounted () {
    delete this.form.id
    this.form.site_id = this.siteId
  }
}

</script>



// WEBPACK FOOTER //
// SiteRevenueAdd.vue?618791fe